<script>
export default {
  name: "testUserDialog",
  props: {
    title: {
      type: String,
      default: "",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      show: false,
      loading: false,
      list: [],
      select: [],
    };
  },
  watch: {
    visible(val) {
      this.show = val;
      if (val) {
        this.getList();
        this.getDetail();
      }
    },
  },
  mounted() {
    this.show = this.visible;
    this.getList();
  },
  methods: {
    getList() {
      this.$cloud.get("account/list", { page: 1, size: 9999 }).then((res) => {
        this.list = res.children.map((v) => {
          v["key"] = v.id;
          v["label"] = v.classes + "-"  + v.realname;
          return v;
        });
      });
    },
    getDetail() {
      console.log("获取试卷信息");
      this.$cloud
        .get("examination/test/detail", { id: this.id })
        .then((res) => {
          console.log("试卷信息", res);
          this.select = res.userIdList;
        });
    },
    handleClose() {
      console.log("关闭");
      this.$emit("update:visible", false);
    },
    closed() {
      this.list = [];
      this.select = [];
    },
    handleSubmit() {
      if (this.select.length === 0) {
        this.$message.error("未选择人员！");
        return;
      }
      this.loading = true;
      this.$cloud
        .post("examination/test/set/user", {
          testId: this.id,
          userList: this.select,
        })
        .then(() => {
          this.$message.success("保存成功");
          this.handleClose();
          this.$emit("refresh");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<template>
  <div>
    <el-dialog
      :title="title + '-人员设置'"
      :visible.sync="show"
      width="1000px"
      @closed="closed"
      :before-close="handleClose"
    >
      <div class="p-6">
        <el-transfer
          filterable
          :titles="['人员', '选中']"
          class="w-full"
          v-model="select"
          :data="list"
        >
        </el-transfer>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="handleSubmit"
          >保 存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<style scoped></style>
